var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.335693,
    width: 16.0938,
    height: 16.0938,
    rx: 8.04688,
    fill: "#FF3296"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34082 5.1106L8.5849 8.35468L11.829 11.5988",
    stroke: "white",
    strokeWidth: 2.16272,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8291 5.1106L8.58502 8.35468L5.34094 11.5988",
    stroke: "white",
    strokeWidth: 2.16272,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.cedf88a93e6838a341fbcdec8552590c.svg";
export { ForwardRef as ReactComponent };